import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, ArrowUpRight } from "lucide-react";
import { getFieldGear, trackEvent } from "@/lib/api";

export function ArtifactsFromArchive() {
  const [products, setProducts] = useState([]);
  const [status, setStatus] = useState("loading"); // loading | ready | empty

  useEffect(() => {
    let active = true;
    getFieldGear()
      .then((d) => {
        if (!active) return;
        const items = d?.products || [];
        setProducts(items);
        setStatus(items.length ? "ready" : "empty");
      })
      .catch(() => active && setStatus("empty"));
    return () => { active = false; };
  }, []);

  if (status !== "ready") return null;

  const thumbs = products.slice(0, 4);

  return (
    <motion.section
      className="mt-16"
      data-testid="artifacts-from-archive"
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45 }}
    >
      <Link
        to="/store"
        data-testid="artifacts-preview-link"
        onClick={() => trackEvent({ event: "home_store_preview_clicked", path: "/", meta: { referrer: "/" } })}
        className="codex-card group flex flex-col items-center gap-6 overflow-hidden p-6 sm:flex-row sm:justify-between"
        style={{ borderColor: "rgba(216,182,106,0.24)" }}
      >
        <div className="min-w-0">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold-soft">Artifacts from the Archive</span>
          <h2 className="mt-1.5 flex items-center gap-2 font-serif text-2xl tracking-tight">
            <ShoppingBag className="h-5 w-5 text-gold-light" /> CODEX Field Gear
          </h2>
          <p className="mt-1.5 text-sm text-muted-foreground">Official apparel and artifacts inspired by the files. Visit the store →</p>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden items-center -space-x-4 sm:flex">
            {thumbs.map((p, i) => (
              p.image ? (
                <span
                  key={p.id}
                  className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl border border-gold-light/25 bg-[#0A1422] shadow-md transition-transform duration-300 group-hover:translate-x-0"
                  style={{ zIndex: thumbs.length - i, transform: `rotate(${(i - 1.5) * 3}deg)` }}
                >
                  <img src={p.image} alt={p.name} loading="lazy" className="h-full w-full object-cover" />
                </span>
              ) : null
            ))}
          </div>
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-gold-light/40 bg-gold-light/[0.06] px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-gold-light transition-colors group-hover:bg-gold-light/[0.12]">
            Visit the store <ArrowUpRight className="h-3.5 w-3.5" />
          </span>
        </div>
      </Link>
    </motion.section>
  );
}
